module.exports = __webpack_public_path__ + "img/map_outfield-picnic-pavilion.e23d9651.jpg";